import Client from './client/CustomerCampaignHistoryClient';

export default {
	getListCustomerCampaignHistory(customerId) {
		return Client.get(`api/CampaignCourse/GetCustomerCampaignCourse?customerId=${customerId}`);
	},
};
